import BG_1 from '../../../assets/images/enrolment-bg-1-3-5.png';
import BG_2 from '../../../assets/images/enrolment-bg-2.png';
import BG_4 from '../../../assets/images/enrolment-bg-4.png';
import OVERLAY_1 from '../../../assets/images/enrolment-overlay-1-shape-1.png';
import OVERLAY_2 from '../../../assets/images/enrolment-overlay-2-shape-2.png';
import OVERLAY_3 from '../../../assets/images/enrolment-overlay-3.png';
import OVERLAY_4 from '../../../assets/images/enrolment-overlay-4-shape-4.png';
import OVERLAY_5 from '../../../assets/images/enrolment-overlay-5-shape-5.png';

const STEP_MAP = {
  1: {
    background: BG_1,
    overlay: OVERLAY_1,
  },
  2: {
    background: BG_2,
    overlay: OVERLAY_2,
  },
  3: {
    background: BG_1,
    overlay: OVERLAY_3,
  },
  4: {
    background: BG_4,
    overlay: OVERLAY_4,
  },
  5: {
    background: BG_1,
    overlay: OVERLAY_5,
  },
};

const RightColumn = ({ step }: { step: number }) => {
  const { background, overlay, shape } = STEP_MAP[step];

  return (
    <div
      className="flex h-full w-full items-start justify-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="sticky top-0 flex h-[100vh] shrink-0 items-center justify-start">
        {shape && (
          <img
            src={shape}
            alt="Cluey Plus shape"
            className="absolute left-1/2 top-1/2 h-auto max-h-[100vh] w-auto max-w-full -translate-x-1/2 -translate-y-1/2 object-contain object-center"
          />
        )}
        <img
          src={overlay}
          alt="Cluey Plus overlay"
          className="sticky z-10 h-full max-h-[100vh] w-auto max-w-full object-contain object-center"
        />
      </div>
    </div>
  );
};

export default RightColumn;
